module.exports = __webpack_public_path__ + "assets/img/ICI-UK-Content-Marketing-w960.84bc6818.jpg";